import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './survey.scss';
import { Box, Button, Typography, Modal, TextField, makeStyles } from '@material-ui/core';
import { useTranslations } from 'sdk/custom-hooks';
import { useDispatch } from 'react-redux';
import { getSurveyAction } from 'sdk/actions/getSurveyAction';
import { useTheme } from '../../constants/themeProvider';
import { useSearchQuery } from '../../services/SearchQueryContext';
import { ReactComponent as SearchIcon } from "../../assets/images/search.svg";
import { ReactComponent as CrossIcon } from "../../assets/images/close.svg";
import NotFound from '../NotFound';

function stripHtml(html) {
  const tmp = document.createElement("p");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

const MyModal = ({ showModal, closeModal, setIsModalVisible }) => {
    const t = useTranslations();
    return (
      <Modal
        open={showModal}
        onClose={closeModal}
        className={`modal-bg ${showModal ? 'show' : ''}`}
        onClick={closeModal}
      >
        <Box
          className='modal-content copy-link-modal'
          onClick={(e) => e.stopPropagation()}
        >
          <Box className='heading'>
            <Typography variant="inherit" className='heading-text'>
              {t('Link_copied_to_clipboard!')}
            </Typography>
            <Box className='ok-align'>
              <Box
                onClick={() => { setIsModalVisible(false) }}
                className='ok-btn'
              >
                {t('Ok')}
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    );
};

  MyModal.propTypes = {
    showModal: PropTypes.bool,
    closeModal: PropTypes.func,
    setIsModalVisible: PropTypes.func,
  };

const Survey = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const dispatch = useDispatch();
    const [surveyData, setSurveyData] = useState([]);
    const [showComponent, setShowComponent] = useState(false);
    const theme = useTheme();
    const { searchQuery, setSearchQuery } = useSearchQuery();
    const t = useTranslations();
    const isFirefox = typeof InstallTrigger !== 'undefined';
    const classes = useStyles(isFirefox);

      function clearField(searchQuery) {
        if(searchQuery.length)
           setSearchQuery('')
      };

    const closeModal = () => {
        setIsModalVisible(false);
    };

    useEffect(()=> {
        dispatch(getSurveyAction()).then((response) => {
            try {
              if (Array?.isArray(response?.data)) {
                setSurveyData(response?.data);
              }
            } catch (error) {
              console.log('Error - ', error.message);
            }
        })
    },[])

    useEffect(() => {
        const timer = setTimeout(() => {
          setShowComponent(true);
        }, 1000);
        return () => clearTimeout(timer);
      }, []);

    const lowerSearchQuery = searchQuery?.toLowerCase().trim();
    const filteredSurveyData = surveyData?.filter((item, index) => {
        const title = item?.title;
        const titleText = stripHtml(title).toLowerCase();
        const lowerTitle = title.toLowerCase();
        return (
        lowerTitle.includes(lowerSearchQuery) ||
        titleText.includes(lowerSearchQuery)
        );
    });
    const filteredSurveys =
    searchQuery && searchQuery.trim() !== ""
    ? filteredSurveyData
    : surveyData;
    const sortedSurveys = [...(filteredSurveys || [])].sort(
      (a, b) => new Date(b?.updated?.on) - new Date(a?.updated?.on)
    );

    useEffect(() => {
        setSearchQuery('')
        return setSearchQuery('');
    }, []);

    return (
        <Box className="survey-container">
            <Box className="course-search-box no-mobile-padding">
                <TextField
                    variant="outlined"
                    placeholder={t('Search')}
                    value={searchQuery}
                    onChange={(event) => setSearchQuery(event?.target?.value)}
                    className="inner-search-box-survey"
                    type="text"
                />
                <Box className="course-search-img-box">
                {searchQuery?.length ? (
                    <Button onClick={()=>clearField(searchQuery)} style={{border:'none'}}>
                      <CrossIcon className="cross-icon" alt="Cross Icon" />
                    </Button>
                  )
                :
                (<SearchIcon className="search-icon" alt="Search Icon" />)
                }
                </Box>
            </Box>
            {
              sortedSurveys.length > 0 ? (
                sortedSurveys.map((item, index) => {
                        const currentTime = Date.now();
                        const scheduledDate = Date.parse(item?.updated?.on);
                        const differenceInMilliseconds = Math.abs(currentTime - scheduledDate);
                        const differenceInSeconds = differenceInMilliseconds / 1000;
                        const differenceInMinutes = differenceInSeconds / 60;
                        const differenceInHours = differenceInMinutes / 60;
                        const differenceInDays = differenceInHours / 24;

                        let timeAgo;
                        if (differenceInMinutes < 60) {
                            timeAgo = `${Math.floor(differenceInMinutes)} min ago`;
                        } else if (differenceInHours < 24) {
                            timeAgo = `${Math.floor(differenceInHours)} h ago`;
                        } else {
                            timeAgo = `${Math.floor(differenceInDays)} d ago`;
                        }
                        const surveyKey = item?._id || `${item?.url || ''}-${item?.updated?.on || ''}-${item?.title || ''}`;
                        return (
                          <Box className="survey-detail-items commonShadow" key={surveyKey}>
                                <Box className="survey">
                                    <Box className="survey-detail-profile-pic">
                                        <Typography className='count-data' style={{color: theme?.primaryColor}}>
                                        {index < 9 ? `0${index + 1}` : index + 1}
                                        </Typography>
                                    </Box>
                                    <Box className="survey-text">
                                    <Box className="survey-content">
                                        <Typography component="a" href={item?.url} target="_blank" className="survey-detail-heading">
                                        {item?.title}
                                        </Typography>
                                        <Typography component="p" className="survey-detail-info">
                                        {timeAgo}
                                        </Typography>
                                    </Box>

                                    </Box>
                                    <Typography component="a" href={item?.url} target="_blank" className="survey-detail-heading">
                                      {t('Open')}
                                    </Typography>
                                </Box>
                            </Box>
                        )
                    })
                ) : showComponent && (
                    <Box className={classes.centerAlign}><NotFound /></Box>
                )
            }
            {isModalVisible && <MyModal
                showModal={isModalVisible}
                closeModal={closeModal}
                setIsModalVisible={setIsModalVisible}
            />}
        </Box>
    );
}
const useStyles = makeStyles(() => ({
  centerAlign: isFirefox => ({
    textAlign: isFirefox ? '-moz-center' : '-webkit-center',
  }),
}));
export default Survey;
